import { ArrowTopRightOnSquareIcon, TrashIcon } from '@heroicons/react/24/outline';
import SharedButton from '../../global/Button/Button';
import { SavedSearch, TabType } from './types';
import { formatDate } from './favoritesUtils';
import SearchDetails from './SearchDetails';

interface SearchCardProps {
  search: SavedSearch;
  activeTab: TabType;
  editId: string | null;
  editName: string;
  onEditChange: (value: string) => void;
  onSaveEdit: (id: string) => void;
  onCancelEdit: () => void;
  onStartEdit: (id: string, name: string) => void;
  onNavigate: (search: SavedSearch) => void;
  onNavigateWithColumns: (search: SavedSearch) => void;
  onNavigateWithScore?: (search: SavedSearch) => void;
  onDelete: (id: string) => void;
}

const SearchCard = ({
  search,
  activeTab,
  editId,
  editName,
  onEditChange,
  onSaveEdit,
  onCancelEdit,
  onStartEdit,
  onNavigate,
  onNavigateWithColumns,
  onNavigateWithScore,
  onDelete,
}: SearchCardProps) => {
  return (
    <div className="saved-filter-card mb-3">
      <div className="d-flex justify-content-between align-items-start">
        <div style={{ flex: 1 }}>
          <div style={{ marginBottom: '8px' }}>
            {editId === search.id ? (
              <input
                type="text"
                value={editName}
                onChange={e => onEditChange(e.target.value)}
                onKeyDown={e => {
                  if (e.key === 'Enter') onSaveEdit(search.id);
                }}
                style={{
                  fontSize: '16px',
                  padding: '2px 6px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  width: '70%',
                }}
                autoFocus
              />
            ) : (
              <span className="text-pink font-bold" style={{ fontSize: '16px' }}>
                {search.name}
              </span>
            )}

            <span style={{ marginLeft: '12px', fontSize: '12px', color: '#666' }}>
              {formatDate(search.savedAt)}
            </span>
          </div>

          <div style={{ marginBottom: '4px' }}>
            <span
              style={{
                background:
                  search.table === 'Evidence'
                    ? '#dbeafe'
                    : search.table === 'Score'
                      ? '#fef3c7'
                      : '#fce7f3',
                color:
                  search.table === 'Evidence'
                    ? '#1e40af'
                    : search.table === 'Score'
                      ? '#92400e'
                      : '#9f1239',
                padding: '2px 8px',
                borderRadius: '4px',
                fontSize: '12px',
                fontWeight: '500',
              }}
            >
              {search.table}
            </span>
          </div>

          <SearchDetails search={search} activeTab={activeTab} />
        </div>

        <div style={{ display: 'flex', gap: '8px', marginLeft: '16px' }}>
          {editId === search.id ? (
            <>
              <SharedButton
                size="xs"
                type="button"
                onClick={() => onSaveEdit(search.id)}
                disabled={!editName.trim()}
              >
                Save
              </SharedButton>
              <SharedButton size="xs" type="button" variant="secondary" onClick={onCancelEdit}>
                Cancel
              </SharedButton>
            </>
          ) : (
            <>
              <SharedButton size="xs" type="button" onClick={() => onStartEdit(search.id, search.name)}>
                Edit
              </SharedButton>
              {activeTab === 'columns' ? (
                <SharedButton size="xs" type="button" onClick={() => onNavigateWithColumns(search)}>
                  <ArrowTopRightOnSquareIcon className="h-4 w-4 mr-2" />
                  {search.type === 'complete' ? 'Apply All' : 'Apply Columns'}
                </SharedButton>
              ) : activeTab === 'scores' && onNavigateWithScore ? (
                <SharedButton size="xs" type="button" onClick={() => onNavigateWithScore(search)}>
                  <ArrowTopRightOnSquareIcon className="h-4 w-4 mr-2" />
                  Apply Score
                </SharedButton>
              ) : (
                <SharedButton size="xs" type="button" onClick={() => onNavigate(search)}>
                  <ArrowTopRightOnSquareIcon className="h-4 w-4 mr-2" />
                  Open
                </SharedButton>
              )}
              <SharedButton size="xs" type="button" onClick={() => onDelete(search.id)}>
                <TrashIcon className="h-4 w-4" />
              </SharedButton>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchCard;
